import packageJson from "../../package.json";

export const getStatus = (idStatus) => {
  return idStatus == 1
    ? "PROGRAMADO"
    : idStatus == 2
    ? "EN PROCESO"
    : idStatus == 3
    ? "CONCLUIDO"
    : "CANCELADO";
};
//deprecated
//export const currentVersion = "2026.01";

export const currentVersion = packageJson.version;
